import isDarkColor from './isDarkColor'

const getThemeAwareColor = (color) => {
  if (typeof color !== 'string') return color

  const normalized = color.trim().toLowerCase()
  const namedColors = { black: '#000000', dimgray: '#696969', dimgrey: '#696969' }
  const value = namedColors[normalized] || normalized
  let channels

  if (/^#[\da-f]{3}$/i.test(value)) {
    channels = [...value.slice(1)].map((channel) => parseInt(channel + channel, 16))
  } else if (/^#[\da-f]{6}$/i.test(value)) {
    channels = value.slice(1).match(/../g).map((channel) => parseInt(channel, 16))
  } else {
    const rgb = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*1(?:\.0+)?\s*)?\)$/)
    if (rgb) channels = rgb.slice(1, 4).map(Number)
  }

  // Adapt only dark, near-neutral text; keep intentional colour accents and transparency.
  if (!channels || !isDarkColor(`rgb(${channels.join(',')})`) || Math.max(...channels) - Math.min(...channels) > 32) {
    return color
  }

  return `var(--rich-text-neutral-color, ${color})`
}

// Render-only copy: never change the document saved by the editor.
export const adaptRichTextColors = (node) => {
  if (!node || typeof node !== 'object') return node
  if (Array.isArray(node)) return node.map(adaptRichTextColors)

  return {
    ...node,
    ...(Array.isArray(node.content) ? { content: node.content.map(adaptRichTextColors) } : {}),
    ...(Array.isArray(node.marks) ? {
      marks: node.marks.map((mark) => mark.type === 'textStyle' && mark.attrs?.color ? {
        ...mark,
        attrs: { ...mark.attrs, color: getThemeAwareColor(mark.attrs.color) },
      } : mark),
    } : {}),
  }
}
